import { createContext } from "react";

type ScrollTopContextType = {
    scrollTop: number,
    setScrollTop: React.Dispatch<React.SetStateAction<number>>
}

const iScrollTopContextState = {
    scrollTop: 0,
    setScrollTop: () => {}
}

const ScrollTopContext = createContext<ScrollTopContextType>(iScrollTopContextState)

export default ScrollTopContext